/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import RoleService from "../../service/role-service.js";

const roleService = new RoleService();

loadDictionary('role-edit-role-window');

function EditRoleWindow({isOpenWindow, onCloseWindow, roleId}) {
  const [id, setId] = useState(0);
  const [name, setName] = useState('');

  const handleClose = () => {
    setId(0);
    setName('');
    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const role = {
      id: parseInt(id),
      name: name,
    };

    roleService.edit(role).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    });
  };

  useEffect(() => {
    if(!isOpenWindow || !roleId) return;

    roleService.findOne(roleId).then(role => {
      if(role) {
        setId(role.id);
        setName(role.name);
      }
    });

  }, [isOpenWindow, roleId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("role-edit-role-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="EditForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("role-edit-role-window.name")}</Form.Label>
              <Form.Control type="text" value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("role-edit-role-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="EditForm" >{i18n.t("role-edit-role-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditRoleWindow;